webpackJsonp([102527728302540],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/shop-merino-super-chunky-scarf.json":
/***/ (function(module, exports) {

	module.exports = {
		"pathContext": {
			"path": "/shop/merino-super-chunky-scarf/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---shop-merino-super-chunky-scarf-95d02ce940d912e21bc0.js